import { Handle, NodeProps, Node, Position } from "@xyflow/react";
import { TABLE_ICONS } from "types/Icons";
import { WorkflowDiagramReactFlowProps } from "../WorkflowDiagramReactFlow";
import { workflowDiagramStyles } from "../workflowDiagramStyles";
import { NodeIcon } from "./NodeIcon";
import { nodeStyles } from "./nodeStyles";

export const InputNode = ({
  data,
  sourcePosition,
  targetPosition,
}: NodeProps<
  Node<WorkflowDiagramReactFlowProps["graphInputs"][number]["data"]>
>) => (
  <div
    style={{ ...nodeStyles.base, ...workflowDiagramStyles.shapes.input }}
    title={data.label}
  >
    <NodeIcon type={TABLE_ICONS.input} label="Input" />
    <div style={nodeStyles.name}>{data.label}</div>
    <Handle
      type="target"
      position={targetPosition ?? Position.Top}
      style={nodeStyles.unusedHandle}
    />
    <Handle type="source" position={sourcePosition ?? Position.Bottom} />
  </div>
);
